export default __webpack_public_path__ + "static/media/calendar.ef988a17.svg";